// extracted by mini-css-extract-plugin
export default {"container":"about_container__dhlx1","header":"about_header__qbTUX","subheader":"about_subheader__uQipD","divider":"about_divider__OARK-","center":"about_center__2DARf"};